import { printQuote as apiPrintQuote } from '~/api/projects2';
import { getReasonForError } from '~/common/getReasonForError';
import { notifyExportQueued } from '~/common/notifyExportQueued';
import { capturePosthogEvent, captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import { Notify } from '~/components2/Notify';

/** Marks a request the API answered but declared unsuccessful, distinct from a network or HTTP failure. */
class ApiDeclaredError extends Error {}

/** Extracted from TabDetails so a failed quote print can be exercised without rendering the component. */
export async function printProjectQuote(
  projectId: string,
  organizationId: string | undefined,
  type: 'docx' | 'pdf',
  ccEmails?: string[],
) {
  try {
    const res = await apiPrintQuote(projectId, type, ccEmails);

    if (!res.success) {
      throw new ApiDeclaredError('Error printing quote');
    }

    notifyExportQueued({
      title: 'Print Quote',
      message: 'Your quote is being processed. You will receive it via email shortly.',
      ccEmails,
    });

    capturePosthogEvent(POSTHOG_EVENTS.projectQuotePrinted, {
      project_id: projectId,
      organization_id: organizationId,
      format: type,
    });
  } catch (err) {
    captureTypedPosthogEvent(POSTHOG_EVENTS.projectQuotePrintFailed, {
      project_id: projectId,
      organization_id: organizationId,
      format: type,
      reason: err instanceof ApiDeclaredError ? 'api_error' : getReasonForError(err),
    });
    Notify.error({
      title: 'Error Printing Quote',
      message: 'Error generating quote. Please try again or contact support.',
    });
    return false;
  }
}
